import React from 'react';
import JPlus from './pearlDoser/jPlus'
// import TimeEnable from './pearlDoser/timeEnable'
import Recipes from './pearlDoser/recipes'
import Schedule from './pearlDoser/schedule'
import DoserDashParent from "./pearlDoser/DoserDashParent";
import DoserMenu from "./pearlDoser/DoserMenu";
import DoserDataLog from "./pearlDoser/DoserDataLog";
import DoserSchedule from "./pearlDoser/DoserSchedule";
import DoserSchedule2 from "./pearlDoser/DoserSchedule2";
import DoserSchedule3 from "./pearlDoser/DoserSchedule3";
import DoserRecipes from "./pearlDoser/DoserRecipes";
import DoserRecipes2 from "./pearlDoser/DoserRecipes2";
import DoserSystemSettings from "./pearlDoser/DoserSystemSettings";
import DoserSystemSettings2 from "./pearlDoser/DoserSystemSettings2";
import DoserAlarmSettings from "./pearlDoser/DoserAlarmSettings";
import DoserCloud from "./pearlDoser/DoserCloud";
import DoserAbout from "./pearlDoser/DoserAbout";
import DoserValvesParent from "./pearlDoser/DoserValvesParent";
import JProSetup from "./pearlDoser/JProSetup";
import {dbVals} from '../../components/utils/http';
import {getParamId2} from '../utils/utils'

import {cl,globs,getRandomString,getTzo,getTime,
  getLocalStorage,saveLocalStorage,showTime,
} from '../../components/utils/utils';
import {wsTrans} from '../utils/utils'
import {getSiteName,getZoneName,loadSensorsInfo,loadSiteData} from './C18utils'
import LoadingSpinner from './loadingSpinner'
import styles from './pearlDoser/pearlDoser.module.css'
import {getRecipe,withTimeout,getDb,readXBoards,getJProBoards,readJPro,
  loadChannelInfo,aiGlobs,filterSchedIrr,
  } from './C18AiUtils.js'
import history from "../../history"

const CHAN = 255;
const TAB = "zone_configuration_settings";
const VOL_UNIT_COLUMN = "Volume Measurement Units"
const TMP_UNIT_COLUMN = "Temperature Units"

class C18PearlDoser00 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    const { zInd }=props
//     cl(props)
//     this.state={
//       loaded:false,
//       selPage:"Dashboard",
//     }
    let pumper={
      nutrientName:"Just One Touch",
      concentration:0.52,
    }
    this.pumpers=[
      pumper,pumper,pumper,pumper,pumper,pumper,pumper,pumper,
      pumper,pumper,pumper,pumper,pumper,pumper,pumper,pumper,]
    this.cps=[
      1,2,3,4,5,6,7,8,
      1,2,3,4,5,6,7,8,]
    this.recipes=[
      {
        recipeId:"abc",name:"one",
        concs:[0.23,0.23,0.23,0.23,0.23,0.23,0.23,0.23,
          0.23,0.23,0.23,0.23,0.23,0.23,0.23,0.23,],
      },
      {
        recipeId:"def",name:"two",
        concs:[0.24,0.23,0.23,0.23,0.23,0.23,0.23,0.23,
          0.23,0.23,0.23,0.23,0.23,0.23,0.23,0.23,],
      },
    ]
    this.schedule=[
      {recipeId:"abc",dayMins:25,durMins:0},
      {recipeId:"def",dayMins:125,durMins:0},
      {recipeId:"abc",dayMins:225,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
    ]
    this.units={
      v:["L","Gal","Gal","Gal","L"],
      c:["L/ml","Gal/oz","Gal/ml","Ratio","Ratio"],
      t:["\u00B0F","\u00B0C"],
    }
    this.state={
//       timeEnables:btoa(String.fromCharCode(...new Uint8Array(18))),
      concs:[0,0,0,0,0,0,0,0,
        0,0,0,0,0,0,0,0,],
      editRecipes:false,
      editSchedule:false,
//       editTimeEnables:false,
      editJPlus:false,
      selRecipe:"none",
      jpEdit:"none",
      recEdit:"none",
      selPage:"Dashboard",
      editRecipe:{
        name:"",
        concs:new Array(64).fill(0),
      },
      pageType:"showDashboard",

      recipes:[
//         {
//           recipeId:"abc",name:"one",
//           concs:[0.23,0.23,0.23,0.23,0.23,0.23,0.23,0.23,
//             0.23,0.23,0.23,0.23,0.23,0.23,0.23,0.23,],
//         },
//         {
//           recipeId:"def",name:"two",
//           concs:[0.24,0,0,0,0,0,0,0,
//             0,0,0,0,0,0,0,0,],
//         },
      ],
      schedule:[
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
      {recipeId:"none",dayMins:0,durMins:0},
    ],
      jPlus:[
        {
          name:"jPlus 1",
          mbAddr:0,
          nutes:["None","None","None","None","None","None","None","None",
          "None","None","None","None","None","None","None","None",],
          cps:[1,2,3,4,5,6,7,8,1,2,3,4,5,6,7,8,],
        }
      ],
    }
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.savePage)
  }

  componentDidMount=()=>{
    this.setBreadCrumbs()
    this.loadInfo()
  }

  componentWillUnmount=()=>{
    this.subscribe_savePageEvent.remove()
  }

  setBreadCrumbs=()=>{
    let p=this.props.parms
//     cl(p)
    let siteName=getSiteName(p.site)
    let zoneName=getZoneName(p.zone)
//     cl(siteName, zoneName)
    if(p){
      p.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:siteName, url:`/usa/c18/sites/${this.props.parms.site}`},
//               {t:zoneName, url:`/usa/c18/sites/${this.props.parms.site}/zones/${this.props.parms.zone}`},
              {t:zoneName, url:`/usa/c18/sites/${p.site}/zones/${p.zone}`},
              {t:"Doser", url:`/usa/c18/sites/${p.site}/zones/${p.zone}/pearlDoser`},
            ]},
        },
      )
    }
  }

//   testGetCycles=async()=>{
// //     cl("getCycles")
//     let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/irrigation",
//       method: "retrieve", sessionId: globs.userData.session.sessionId,
//       body: {
//         siteId:"LSkI5oiyCAARlsJo",
//         cmd:"getCycles",
//         tz:(new Date()).getTimezoneOffset(),
//         fromTs:1777532400,
//         toTs:1777647600,
//       }})
// //     cl(res.data)
//   }

  getContTzo=(zone)=>{
    let contTimeId=getParamId2(1900,"snapshots","currentTime")
    let contTime=dbVals.z[zone.siteZoneIndex][240][contTimeId]
    let tzo=Math.round((getTime()-contTime)/3600)*60
    return ((tzo>=-720)&&(tzo<=720))?tzo:null
  }

  loadInfo=async()=>{
//     await this.testGetCycles()
    showTime("start1a")
    let pa=this.props.parms
//     cl(pa)
    let body={
      zoneId:pa.zone,
    }
    showTime("start1b")
    await loadSensorsInfo()
    showTime("start1c")
    await loadSiteData(pa.site)
    showTime("start1d")
    await loadChannelInfo(pa.site)
    showTime("start2")
    let site=globs.sitesInfo.info.find(s=>s.siteId==pa.site)
//     cl(site)
    let zone=globs.zonesInfo.info.find(z=>z.zoneId==pa.zone)
    let gw=globs.gatewaysInfo.info.find(g=>g.gatewayId==zone.gatewayId)
    showTime("start3")
//     cl(site)
//     let zoneInfo=globs.zonesInfo.info.find(z=>z.zoneId==pa.zone)
//     cl(zoneInfo)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlDoser", method: "retrieve",
      sessionId: globs.userData.session.sessionId, body: body})
    let zoneInfo=globs.zonesInfo.info.find(z=>z.zoneId==pa.zone)
    let xBoards=readXBoards(zoneInfo.siteZoneIndex)
    let jProBoards=getJProBoards(xBoards)
    showTime("start4")
//     cl(jProBoards)

//     cl(res)
    let stateVals={
      loaded:true,
      fwVersion:gw.fwVersion,
      tzo:getTzo(site?.timeZone||"America/Los_Angeles"),
      zoneInfo,//:globs.zonesInfo.info.find(z=>z.zoneId==pa.zone),
      xBoards,
    }
    for(let val of res.data){
      stateVals[val.type]=val.value
    };
    showTime("start5")
    stateVals.jPro = readJPro(
      zone.siteZoneIndex,
      xBoards,
      (stateVals.jPlus || []).length
    );
//     cl(stateVals)
    for(let i=0;i<jProBoards.length;i++){
      stateVals.jPlus[i].mbAddr= xBoards[jProBoards[i]].addIndex
    }
//     cl(stateVals)
    stateVals.vUnitId=+(getDb(zone.siteZoneIndex, CHAN, TAB, VOL_UNIT_COLUMN, 0)||0)
    stateVals.tUnitId=+(getDb(zone.siteZoneIndex, CHAN, TAB, TMP_UNIT_COLUMN, 0)||0)

    stateVals.jpUnit=stateVals?.jPlus?.[0]?.name||"JPro"
    stateVals.schedule=(stateVals?.schedule||[]).slice(0,6);
    (stateVals.schedule||[]).forEach((s,i)=>{
      if(!s.durMins){s.durMins=0}
    });
    stateVals.zones=globs.zonesInfo.info.filter(z=>z.siteId==pa.site)
    showTime("start6")
    let irrModeId=getParamId2(1900,
      "zone_configuration_settings","Irrigation Mode")
//     cl(irrModeId)

    stateVals.zones.forEach(z=>{
      z.sequential=(dbVals.z[z.siteZoneIndex][255][irrModeId]==0)
      z.contTzo=this.getContTzo(z)
//       cl(z.siteZoneIndex,dbVals.z[z.siteZoneIndex][255][irrModeId])
    })
//     cl(stateVals.zones)
    let iDoserPage=getLocalStorage("iDoserPage")
    if(!iDoserPage||iDoserPage=="null")(iDoserPage="Dashboard")
    await this.menuChange({value:iDoserPage})
//     cl(stateVals)
    showTime("start7")
    this.setState((stateVals))
  }

  doSave=async(field)=>{
    cl(`save ${field}`)
    let pa=this.props.parms
    let st=this.state
    let body={
      zoneId:pa.zone,
      type:field,
      value:st[field]
    }
//     cl(body)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlDoser", method: "update",
      sessionId: globs.userData.session.sessionId, body: body})
  }

//   saveSchedule=async()=>{
//     doSave("schedule")
// //     let pa=this.props.parms
// //     let st=this.state
// //     let body={
// //       zoneId:pa.zone,
// //       type:"schedule",
// //       value:st.schedule
// //     }
// //     let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlDoser", method: "update",
// //       sessionId: globs.userData.session.sessionId, body: body})
//   }

  saveEditRecipe=()=>{
    let st=this.state
    let recipes=st.recipes.slice(0)
    let selRecipe=st.recipes.filter(r=>r.recipeId==st.selRecipe)[0]
    if(!selRecipe){
      recipes.push(st.editRecipe)
    }else{
      selRecipe.name=st.editRecipe.name
      selRecipe.concs=st.editRecipe.concs.slice(0)
    }
//     cl(selRecipe.name)
    this.setState({recipes:recipes})
  }

  savePage=async()=>{
    let st=this.state
//     cl("savePage")
//     globs.events.publish("savePageEnable",false)
//     if(st.editRecipes){
//       this.saveEditRecipe()
//       await this.doSave("recipes")
//     }
//     if(st.editSchedule){await this.doSave("schedule")}
// //     if(st.editTimeEnables){await this.doSave("timeEnables")}
//     if(st.editJPlus){await this.doSave("jPlus")}
    if(st.editValves){
      await this.doSave("valves")
      globs.events.publish("saveOK",true)
    }
//     globs.events.publish("saveOK",true)
  }

  onJPlusChange=(values)=>{
//     cl(values)
    let st=this.state
//     values.unit=0// tempFix
    let jPlus=st.jPlus.slice(0)
    if(values.type!="edit"){globs.events.publish("savePageEnable",true)}
    var setVal
    switch(values.type){
      case "jpName":
        jPlus[values.jpIndex].name=values.value
        break
      case "jpModbus":
        jPlus[values.jpIndex].mbAddr=values.value
        cl(jPlus)
        break
      case "nuteName":
        jPlus[values.jpIndex].nutes[values.index]=values.value
//         cl(values.index+16*values.jpIndex)
//         cl(jPlus)
        break
      case "nuteConc":
        let editRecipe=Object.assign(st.editRecipe)
        editRecipe.concs[values.index+16*values.jpIndex]=values.value
        this.setState({editRecipe:editRecipe,editRecipes:true})
        break
      case "edit":
//         cl(st.selRecipe,values.value)
        if((st.selRecipe!="none")||(values.value!="nuteConc")){
//           cl("set edit")
          this.setEditMode("jpEdit",values.value)

        }
        break
    }
    this.setState({jPlus:jPlus,editJPlus:true})
  }

//   onTimeEnableChange=(values)=>{
// //     return
//     globs.events.publish("savePageEnable",true)
//     let str=btoa(String.fromCharCode(...values))
//     this.setState({timeEnables:str,editTimeEnables:true/*,jpEdit:"none"*/})
//   }

  onScheduleChange=(values)=>{
    cl(values)
    let st=this.state
    let schedule=st.schedule.slice(0)
    globs.events.publish("savePageEnable",true)
    switch(values.type){
      case "time":
        schedule[values.index-1].dayMins=values.value
        break
      case "recipe":
        schedule[values.index-1].recipeId=values.value
        break
      case "duration":
        schedule[values.index-1].durMins=values.value
        break
    }
    this.setState({schedule:schedule,editSchedule:true/*,jpEdit:"none"*/})
  }

//   newRecipe=()=>{
//     this.setState({editRecipe:{
//       name:"New Recipe",
//       concs:new Array(64).fill(0),
//     }})
//   }

  deleteRecipe=()=>{
    let st=this.state
    cl("delete recipe")
    let recipes=st.recipes.filter(r=>r.recipeId!=st.selRecipe)
    let editRecipe={
      recipeId:"none",
      name:"",
      concs:new Array(64).fill(0),
    }
    let schedule=st.schedule.slice(0)
    schedule.forEach(s=>{
      if(s.recipeId==st.selRecipe){
        s.recipeId="none"
        s.dayMins=0
        s.durMins=0
      }
    })
    this.setState({
      selRecipe:"none",
      recipes:recipes,
      editRecipes:true,
      editRecipe:editRecipe})
  }

  newRecipe=()=>{
    let st=this.state
    cl("newRecipe")
    cl(st)
    let editRecipe={
      recipeId:getRandomString(16),
      name:`New Recipe ${st.recipes.length+1}`,
      concs:new Array(64).fill(0),
    }
    let pushRecipe=Object.assign({},editRecipe)
    pushRecipe.concs=editRecipe.concs.slice(0)
    let recipes=st.recipes.slice(0)
    recipes.push(pushRecipe)
    this.setState({
      recipes:recipes,
      editRecipe:editRecipe,
      editRecipes:true,
      selRecipe:pushRecipe.recipeId})
  }

  setEditMode=(cont,mode)=>{
//     cl(cont,mode)
    let stateVals={};
    ["recEdit","jpEdit"].forEach(c=>{
      stateVals[c]=(c==cont)?mode:"none"
    })
//     cl(stateVals)
    this.setState(stateVals)
  }

  onRecipesChange=(values)=>{
    let st=this.state
    if(!["select","edit"].includes(values.type)){globs.events.publish("savePageEnable",true)}
//     cl(values)
//     cl(st.recipes)
    var editRecipe, editRecipe
    switch(values.type){
      case "name":
        editRecipe=Object.assign(st.editRecipe)
        editRecipe.name=values.value
        this.setState({editRecipe:editRecipe,editRecipes:true/*,jpEdit:"none"*/})
        break
      case "select":
        if(values.value=="new"){return this.newRecipe()}
        let selRecipe=st.recipes.filter(r=>r.recipeId==values.value)[0]
        if(selRecipe){
          editRecipe={
            name:selRecipe.name,
            concs:selRecipe.concs.slice(0)
          }
        }else{
          editRecipe={
            name:"No Recipe Selected",
            concs:new Array(64).fill(0),
          }
        }
        this.setState({
          selRecipe:values.value,
          editRecipe:editRecipe,
          editRecipes:false,
        })
        break
      case "new":
        this.newRecipe()
        break
      case "delete":
        this.deleteRecipe()
        break
      case "edit":
//         this.setState({recEdit:values.value})
//         this.setState()
        if(st.selRecipe!="none"){this.setEditMode("recEdit",values.value)}
        break
    }

  }

//   toggleJpEdit=(mode)=>{
//     cl("toggle")
//     this.setState({jpEdit:(this.state.jpEdit==mode)?"none":mode})
//   }
//
//   enNute=()=>{this.toggleJpEdit("nuteName")}
//   enMB=()=>{this.toggleJpEdit("jpModbus")}
//   enConc=()=>{this.toggleJpEdit("nuteConc")}
//
//   showEnables=()=>{
//     return(
//       <div>
//         <br/><button type="button" onClick={this.enMB}>Modbus</button>&nbsp;
//         <button type="button" onClick={this.enNute}>Nute</button>&nbsp;
//         <button type="button" onClick={this.enConc}>Conc</button>&nbsp;<br/>
//       </div>
//     )
//   }

  showJPlus=()=>{
    let st=this.state
    cl(this.makeUnits())
    return st.jPlus.filter(jp=>!jp.notUsed)
      .map((jp,ind)=>{
//         cl(jp)
      let pumpers=[]
      for(let i=0;i<16;i++){
        pumpers.push({
          nutrientName:jp.nutes[i],
          concentration:st.editRecipe.concs[16*ind+i]||0,
        })
      }
//       cl(pumpers)
      return(
        <React.Fragment key={ind}>
          <JPlus
            jpIndex={ind}
            config={{
              name:jp.name,
              modbusAddress:jp.mbAddr,
              pumpers:pumpers,
              cps:this.cps,
            }}
            units={this.makeUnits()}
            editMode={st.jpEdit}
            onChange={this.onJPlusChange}
          />
          {(ind<st.jPlus.length-1)&&
            <hr/>
          }
        </React.Fragment>
      )
    })
  }

  pageMouseDown=(e)=>{// should block if *not* editing
    let st=this.state
    if((st.jpEdit=="none")&&(st.recEdit=="none")){return}
    if(e.target.id.substring(0,4)!="edit"){this.setEditMode()}
  }

  addJPlus=()=>{
//     cl("addJPlus")
    let st=this.state
    let jPlus=st.jPlus.slice(0)
    let ind=jPlus.filter(jp=>!jp.notUsed).length
    if(jPlus[ind]){
      jPlus[ind].notUsed=false
    }else{
      jPlus.push(
        {
          name:`jPlus ${ind+1}`,
          mbAddr:0,
          nutes:["None","None","None","None","None","None","None","None",
          "None","None","None","None","None","None","None","None",],
          cps:[1,2,3,4,5,6,7,8,1,2,3,4,5,6,7,8,],
        }
      )
    }
    this.setState({jPlus,editJPlus:true})
  }

  delJPlus=()=>{
    let st=this.state
//     cl("delJPlus")
    let jPlus=st.jPlus.slice(0)
    for(let i=jPlus.length-1;i>=0;i--){
      let jp=jPlus[i]
      if(!jp.notUsed){jp.notUsed=true;break}
    }
//     jPlus[jPlus.length-1].notUsed=true
    this.setState({jPlus,editJPlus:true})
  }

  showRecipeSettings=()=>{
    let st=this.state
    cl(st.schedule)
    return(
      <div className={styles.pearlDoser}
      style={{padding:20}}
        onMouseDown={this.pageMouseDown}
      >
        <h3>Schedule</h3>
        <Schedule
          recipeNames={st.recipes}
          schedule={st.schedule}
          onChange={this.onScheduleChange}
        /><br/>
        <h3>Edit Recipes</h3>
        <div
          className={styles.borderDiv}
        >
          <Recipes
            names={st.recipes}
            selectedId={st.selRecipe}
            editMode={st.recEdit}
            editName={st.editRecipe.name}
            notSaved={false}
            onChange={this.onRecipesChange}
          />
          {st.editRecipes&&
            <span style={{fontSize:18,fontWeight:700,color:"#c0c000"}}>
            Not Saved<br/>&nbsp;</span>
          }
          {this.showJPlus()}
          <span
            onClick={this.addJPlus}
            className={styles.charButAz}
          >+</span>&nbsp;
          <span
            onClick={this.delJPlus}
            className={styles.charButR}
          >x</span>
        </div>
      </div>
    )
  }

  showDashboard=()=>{
    let st=this.state
//     cl(st)
    return(
      <div>
        <DoserDashParent
          zInd={st.zoneInfo.siteZoneIndex}
          zoneId={st.zoneInfo.zoneId}
          mode={st.mode}
          recipeSegments={st.recipeSegments}
          tzo={st.tzo}
          units={this.makeUnits()}
        />
      </div>
    )
  }

//   showDashboard=()=>{
//     return(
//       <div style={{ padding: 20 }}>
//         <DoserDashboard
//           systemStatus="running"
//           onChange={this.dashboardChange}
//           curEc={2.45}
//           spEc={2.30}
//           locLoEc={2.0}
//           locHiEc={2.8}
//           calEc={0.05}
//
//           ecValues={[
//             { ts: Math.floor(Date.now() / 1000) - 3600, ec: 2.2 },
//             { ts: Math.floor(Date.now() / 1000) - 1800, ec: 2.3 },
//             { ts: Math.floor(Date.now() / 1000) - 600, ec: 2.45 }
//           ]}
//           tzo={-300}
//
//           curPh={5.8}
//           spPh={5.6}
//           locLoPh={5.2}
//           locHiPh={6.2}
//           calPh={0.02}
//
//           curFlow={12.4}
//           minFlow={10}
//           maxFlow={15}
//           todayFlow={320.5}
//           weekFlow={1800.2}
//
//           injectors={[
//             { nute: "N", cps: 4, todayInject: 3.2 },
//             { nute: "P", cps: 3, todayInject: 2.1 },
//             { nute: "K", cps: 5, todayInject: 4.8 },
//             { nute: "Ca", cps: 2, todayInject: 1.5 },
//             { nute: "Mg", cps: 2, todayInject: 1.1 }
//           ]}
//
//           curRecipe={{
//             name: "Tomato Veg",
//             startTime: 8 * 60,
//             endTime: 14 * 60,
//             totalFlow: 120.5,
//             nutes: [
//               { inj: 0, conc: 4.2 },
//               { inj: 1, conc: 2.8 },
//               { inj: 2, conc: 5.1 }
//             ]
//           }}
//
//           kFactor={450}
//         />
//       </div>
//     )
//   }

  showDataLog=()=>{
    let pa=this.props.parms
    let st=this.state
//     cl(pa)
    return(
      <div style={{ padding: 20, width:"100%" }}>
        <DoserDataLog
          siteId={pa.site}//"LSkI5oiyCAARlsJo"
          zoneId={pa.zone}//"ZMFsZq-BN8gwDFe7"
          valves={st.valves}
          units={this.makeUnits()}
          mode={st.mode}
          tzo={0-st.tzo}//"-420"
        />
      </div>
    )
  }

  showScheduleSettings=()=>{
    let pa=this.props.parms
    return(
      <div style={{ padding: 20 }}>
        <DoserSchedule
          parms={{zone:pa.zone}}
          onChange={this.pageChange}
        />
      </div>
    )
  }

  showScheduleSettings2=()=>{
    let pa=this.props.parms
    let {zones,valves,recipes,recipeSegments, simple, mode}=this.state
//     cl(mode)
//     cl(this.state)
//     cl(aiGlobs)
    return(
      <div id="/doserSchedule" style={{ padding: 0, width: "100%" }}>
        <DoserSchedule2
          parms={{
            zone:pa.zone,
            channels:aiGlobs.channels,//filterSchedIrr(aiGlobs.channels),
            recipes,
            recipeSegments,
            simple,
            zones,
            valves,
            mode,

          }}
          onChange={this.pageChange}
        />
      </div>
    )
  }

  showPrograms=()=>{
    let pa=this.props.parms
    let {zones,valves,recipes,recipeSegments,tzo,mode}=this.state
//     cl(mode)
    return(
      <div id="/doserPrograms" style={{ padding: 0, flex: "1 1 0", minWidth: 0, overflow: "hidden" }}>
        <DoserSchedule3
          parms={{
            zone:pa.zone,
            channels:aiGlobs.channels,
            recipes,
            recipeSegments,
            zones,
            valves,
            tzo,
            mode,
          }}
          onChange={this.pageChange}
        />
      </div>
    )
  }

  showRecipesSettings=()=>{
    let pa=this.props.parms
    return(
      <div style={{ padding: 20 }}>
        <DoserRecipes
          parms={{zone:pa.zone,getPopup:pa.getPopup}}
          units={this.makeUnits()}
          onChange={this.pageChange}
        />
      </div>
    )
  }

  showRecipesSettings2=()=>{
    let pa=this.props.parms
//     cl(this.state)
    let {jPlus,recipes,schedule,valves,xBoards,zoneInfo}=this.state
    return(
      <div style={{ padding: 0, width: "100%" }}>
        <DoserRecipes2
          parms={{zone:pa.zone,getPopup:pa.getPopup}}
          jPlus={jPlus}
          recipes={recipes}
          schedule={schedule}
          valves={valves}
          xBoards={xBoards}
          zoneInfo={zoneInfo}
          units={this.makeUnits()}
          onChange={this.pageChange}
        />
      </div>
    )
  }

  showAlarmsSettings=()=>{
    let st=this.state
//     cl(st)
    return(
      <div style={{ padding: 20 }}>
        <DoserAlarmSettings
          zInd={st.zoneInfo.siteZoneIndex}
          onChange={this.pageChange}
        />
      </div>
    )
  }

  showCloud=()=>{
    return(
      <div style={{ padding: 20 }}>
        <DoserCloud
        />
      </div>
    )
  }

  showAbout=()=>{
    return(
      <div style={{ padding: 20 }}>
        <DoserAbout
        />
      </div>
    )
  }

  valvesChange=(values)=>{
//     cl(values)
    if(values.type!="edit"){globs.events.publish("savePageEnable",true)}
    this.setState({valves:values.val,editValves:true})
  }

  showValves=()=>{
    let st=this.state
    return(
      <div style={{ padding: 20 }}>
        <DoserValvesParent
        valves={st.valves||[]}
        mode={st.mode}
        onChange={this.valvesChange}
        />
      </div>
    )
  }

  showJProSetup=()=>{
    let pa=this.props.parms
    return(
      <div style={{ padding: 0, width: "100%" }}>
        <JProSetup
          parms={{zone:pa.zone}}
          onChange={this.pageChange}
        />
      </div>
    )
  }

  makeUnits=()=>{
    const {vUnitId,tUnitId}=this.state
    return{
      v:this.units.v[vUnitId],
      c:this.units.c[vUnitId],
      t:this.units.t[tUnitId],
      e:"mS",
    }
  }

  settingsChange=(values)=>{
//     cl(this.state)
//     cl(values)
    switch(values?.type){
      case "state":
        if (Array.isArray(values.value)) {
          this.setState({ jPlus: values.value })
        } else if (values.value) {
          this.setState(values.value)
        }
        return
        break
      case "change":
        this.pageSaves[this.state.selPage]=values.value
        break
      default:
        let upds={};
        (values || []).forEach(v=>{
          upds[v.type]=v.value
    //       cl(v)
        })
        this.setState(upds)
        break
    }
//     if (values && values.type === "state") {
//     }
//     cl(upds)
  }

  showSystemSettings=()=>{
    let st=this.state
    return(
      <div style={{ padding: 20 }}>
        <DoserSystemSettings
          zInd={st.zoneInfo.siteZoneIndex}
          vUnitId={st.vUnitId}
          tUnitId={st.tUnitId}
          onChange={this.settingsChange}
        />
      </div>
    )
  }

  showSystemSettings2=()=>{
//     let st=this.state
    let {zoneInfo,schedule, recipes, jPlus, jPro, valves, vUnitId,
      tUnitId}=this.state
//     cl(jPlus)
//     cl(st)
    return(
      <div style={{ padding: 20 }}>
        <DoserSystemSettings2
          zInd={/*st.*/zoneInfo.siteZoneIndex}
          zoneId={zoneInfo.zoneId}
          vUnitId={/*st.*/vUnitId}
          tUnitId={/*st.*/tUnitId}
          schedule={schedule}
          recipes={recipes}
          jPlus={jPlus}
          jPro={jPro}
          valves={valves}
          onChange={this.settingsChange}
        />
      </div>
    )
  }

  navPearl=()=>{
//     cl("navPearl")
    let st=this.state
    let pa=this.props.parms
//     cl(st)
//     cl(pa)
    let url=`/usa/c18/sites/${pa.site}/zones/${pa.zone}`
//     cl(url)
// https://localhost.link4cloud.com:3104
// /usa/c18/sites/2wnHmnQMy4BtozyW/zones/1I_RnknFFPinx4d0/pearlDoser
//     let url=
    history.push(url)
  }

  onPageClick=(v)=>{
    switch(v.value){
      case "info":
        switch(v.page){
          case "schedule":
            globs.events.publish("showInfoPage",`/doserSchedule_${v.src}`)
            break
          default:
            break
        }
        cl(v)
        break
      default:
        break
    }
  }

  childUpdate=(v)=>{
//     cl(this.state)
//     cl(v)
    this.setState(v.value)
  }

  pageSaves={}

  pageChange=(v)=>{
    let st=this.state
//     cl(st.selPage,v)
    switch(v.type){
      case "change":
        this.pageSaves[st.selPage]=v.value
        break
      case "click":
        return this.onPageClick(v)
      case "update":
        return this.childUpdate(v)
    }
  }

  checkPageSave=async()=>{
    let st=this.state
//     cl(this.pageSaves)
    if(this.pageSaves[st.selPage]){
      let res=await this.props.parms.getPopup({text:"Do you want to save your changes to this page?",buttons:["No","Yes"]})
//       cl(res)
      if(res=="Yes"){
//         cl("save page")
        let res=await withTimeout(this.pageSaves[st.selPage](),5000)
//         cl(res)
//         await this.pageSaves[st.selPage]()
//         cl("save done")
      }
      delete this.pageSaves[st.selPage]
    }
  }

  menuChange=async(v)=>{
//     cl(v)
    if(v.value=="back"){return this.navPearl()}// history.goBack()
    if(v.value=="Pearl"){return this.navPearl()}
    let onChange=this.props.parms.onChange
    if(onChange)
      onChange({cmd:"savePage",data:{
        savePage:!["Dashboard","Data Log","Cloud","About"].includes(v.value)}
      })
    let modes={
      "Dashboard":"showDashboard",
      "Data Log":"showDataLog",
//       "Alarms":"alarms",
      "Schedule":"showScheduleSettings2",
      "Old Schedule":"showScheduleSettings",
      "Recipes":"showRecipesSettings2",
      "Programs":"showPrograms",
      "Old Recipes":"showRecipesSettings",
      "Alarms":"showAlarmsSettings",
      "Valves":"showValves",
      "JPro Setup":"showJProSetup",
      "System":"showSystemSettings2",
      "Old System":"showSystemSettings",
      "Settings":"showRecipeSettings",
      "Cloud":"showCloud",
      "About":"showAbout",
    }
    await this.checkPageSave()
    saveLocalStorage("iDoserPage",v.value)
//     cl(v.value,modes[v.value])
//     cl("checkPageDone")
    this.setState({selPage:v.value,pageType:modes[v.value]})
//     cl(v)
  }

  showMenu=()=>{
    let st=this.state
    return(
      <DoserMenu
        unit={st.jpUnit}
        type="HE Anderson"
        selPage={st.selPage}
        alarms={2}
        fwVers={st.fwVersion}
        prdRev="1.0"
        onChange={this.menuChange}
      />
    )
  }

  render(){
//           {this.showMenu()}
//           {this.showDashboard()}
    let st=this.state
//     cl(st.jpEdit)
//     cl(st)
    if(st.loaded){
      return(
        <div style={{ display: "flex", alignItems: "flex-start" }}
          id="/doserDash"
        >
          {this.showMenu()}
          {this[st.pageType]()}
        </div>
      )
    }else{
      return <LoadingSpinner message="loading accesses..." />
    }
//           <TimeEnable
//             values={Uint8Array.from(atob(st.timeEnables), c => c.charCodeAt(0))}
//             onChange={this.onTimeEnableChange}
//           /><br/>
  }
}

export default C18PearlDoser00;
